import * as React from 'react';
import { Icon,Dialog, Button } from "@alifd/next";
import doLog from '../../common/log';
import "./index.scss";

const { Component,Fragment } = React;

interface propTypes {
    productId: string;
    belt: {
        atomId: string;
        materialJSON: {
            styles: {
              logoImg: string;
              logoHeight: string;
              backgroundColor: string;
            }
            texts: {
                viewMoreLinkPC: string;
                actionUrl: string;
                actionCopy: string;
                tc: string;
                descriptions: [{
                    value: string;
                }]
                title: string
            }
        }
    }[];
    i18n: {},
    resource: {
      atomId: string;
      materialJSON: {
          styles: {
            backgroundImage: string
            backgroundColor: string
            logoImg: string
          }
          texts: {
              viewMoreLinkPC: string;
              tc: string;
              descriptions: [{
                  value: string;
              }]
              title: string
          }
      }
  }[];
}

export default class Pop extends Component<propTypes> {
    state = {
        visible: false
    }
    constructor( props: propTypes | Readonly<propTypes> ) {
        super( props );
    }
    handleClick = () => {
      const {productId} = this.props;
      doLog( '/sc.details.commonLogs',`productId=${productId}&action=PromotionClk` );
        this.setState( {
            visible: true
        } )
    }
    render () {
        const { visible } = this.state;
        const { belt, resource, i18n } = this.props;
        
        return (
            <Fragment>
                <div className="detail-promotion" onClick={this.handleClick.bind( this )} style={{
                  backgroundImage: `url(${resource[0].materialJSON?.styles?.backgroundImage})`
                }}>
                    <img src={resource[0].materialJSON?.styles?.logoImg} />
                    <div className='pro-item'>
                      <div className='pro-info'>
                            {resource.map(item => <span className="promotion-text">
                               {item.materialJSON?.texts?.title}
                            </span>)}
                      </div>
                            <Icon type="arrow-right" size="xs" />
                    </div>
                </div>
                <Dialog
                    title={i18n["detail_app_atmosphere_pop_ups_title"]}
                    visible={visible}
                    onOk={this.handleClick.bind( this )}
                    onCancel={() => this.setState( {
                        visible: false
                    } )}
                    onClose={() => this.setState( {
                        visible: false
                    } )}
                    footerActions={[]}
                    style={{
                        width: "600px",
                    }}
                >
                    <div className="promotion-dialog">
                    <img src={belt[0].materialJSON?.styles?.logoImg} style={{
                    height: belt[0].materialJSON?.styles?.logoHeight ? `${belt[0].materialJSON?.styles?.logoHeight}px` : 'auto'
                  }}/>
                        {belt.map( item => (
                            <div key={item.atomId} className='pop-item-ly' style={{
                              backgroundColor: item?.materialJSON?.styles?.backgroundColor || '#fff'
                            }}>
                                <h3>{item.materialJSON?.texts?.title}</h3>
                                <p>{item.materialJSON?.texts?.descriptions}</p>
                                {item.materialJSON?.texts?.actionCopy 
                                && item.materialJSON?.texts?.actionUrl  ?
                                <div>
                                  <Button className='pop-url' type="secondary" component="a" target='_blank' size="small" href={item.materialJSON.texts?.actionUrl}>{item.materialJSON.texts?.actionCopy}</Button>
                                </div>
                                : null
                                }
                            </div>
                        ) )}
                        {belt[0].materialJSON?.texts?.viewMoreLinkPC && <a
                            href={belt[0].materialJSON?.texts?.viewMoreLinkPC}
                            target="_blank"
                            className='pop-lk'
                            dangerouslySetInnerHTML={{
                                __html: belt[0].materialJSON?.texts?.tc,
                            }}
                        />}
                    </div>
                </Dialog>
            </Fragment>
        )
    }
}